import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { Table, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import Loader from '../components/Loader/Loader';
import { ButtonSearch } from '../components/Buttons/Buttons';
import ButtonView from '../components/Buttons/ButtonView';
import UsuariosService from '../axios_services/usuarios.service';
import { AppContext } from '../application/provider';
import '../components/Modal/ModalCrearUsuario.css';
import './SesionesActivas.css';

const hoy = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

function SesionesActivas() {
    const [state] = useContext(AppContext);
    const [estados_sesion] = useState(
        state.catalogos.tipos.filter(t => t.categoria_id == 44)
    );

    const coloresEstado = { 1: '#3cb167', 2: '#6b7280', 3: '#ef4444' };
    const [sesiones, setSesiones] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [modalSesion, setModalSesion] = useState(false);
    const [sesionSeleccionada, setSesionSeleccionada] = useState(null);
    const [fecha, setFecha] = useState(hoy());
    const [nombre, setNombre] = useState('');
    const [filtroRiesgo, setFiltroRiesgo] = useState('todos');
    const initialFetchDone = useRef(false);

    useEffect(() => {
        if (!initialFetchDone.current) {
            cargarSesiones();
            initialFetchDone.current = true;
        }
    }, []);

    const cargarSesiones = async () => {
        setIsLoading(true);
        try {
            const data = await UsuariosService.getSesionesActivas();
            setSesiones(data || []);
        } catch (error) {
            console.error(error);
            setSesiones([]);
        } finally {
            setIsLoading(false);
        }
    };

    const abrirModal = (item) => {
        setSesionSeleccionada(item);
        setModalSesion(true);
    };

    const cerrarModal = () => {
        setModalSesion(false);
    };

    const formatFecha = (f) => {
        if (!f) return '—';
        return new Date(f).toLocaleString('es-PE', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const getRiesgo = (totalActivas) => {
        if (totalActivas >= 3) return { label: 'Crítico', color: '#ef4444' };
        if (totalActivas === 2) return { label: 'Moderado', color: '#f59e0b' };
        return { label: 'Normal', color: '#3cb167' };
    };

    const sesionesFiltradas = useMemo(() => {
        return sesiones
            .filter(item => {
                const coincideNombre = nombre
                    ? item.nombre_completo.toLowerCase().includes(nombre.toLowerCase()) ||
                    item.codigo_usuario.toLowerCase().includes(nombre.toLowerCase())
                    : true;
                return coincideNombre;
            })
            .map(item => {
                const sessFiltradas = fecha
                    ? item.sesiones.filter(s => s.fecha_login && s.fecha_login.startsWith(fecha))
                    : item.sesiones;
                const totalActivas = sessFiltradas.filter(s => Number(s.estado) === 1).length;
                return { ...item, sesiones: sessFiltradas, total_sesiones: sessFiltradas.length, total_activas: totalActivas };
            })
            .filter(item => item.sesiones.length > 0)
            .filter(item => {
                if (filtroRiesgo === 'normal') return item.total_activas <= 1;
                if (filtroRiesgo === 'moderado') return item.total_activas === 2;
                if (filtroRiesgo === 'critico') return item.total_activas >= 3;
                return true;
            });
    }, [sesiones, fecha, nombre, filtroRiesgo]);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="sesiones-activas-container">
            <h1>HISTORIAL DE SESIONES</h1>

            <div className="filtros">
                <div className="campo-fecha">
                    <label htmlFor="fecha_sesion">Fecha:</label>
                    <input
                        id="fecha_sesion"
                        type="date"
                        value={fecha}
                        onChange={(e) => setFecha(e.target.value)}
                    />
                </div>
                <div className="campo-fecha">
                    <label htmlFor="nombre_usuario">Nombre / Código:</label>
                    <input
                        id="nombre_usuario"
                        type="text"
                        value={nombre}
                        placeholder="Buscar usuario..."
                        onChange={(e) => setNombre(e.target.value)}
                    />
                </div>
                <div className="campo-fecha">
                    <label htmlFor="filtro_riesgo">Nivel de acceso:</label>
                    <select
                        id="filtro_riesgo"
                        value={filtroRiesgo}
                        onChange={(e) => setFiltroRiesgo(e.target.value)}
                    >
                        <option value="todos">Todos</option>
                        <option value="normal">Normal — 0 a 1 sesión activa</option>
                        <option value="moderado">Moderado — 2 sesiones activas</option>
                        <option value="critico">Crítico — 3 o más sesiones activas</option>
                    </select>
                </div>
            </div>

            <ButtonSearch onClick={cargarSesiones} isLoading={isLoading}></ButtonSearch>

            <div className="table-container">
                <Table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th>Conexiones</th>
                            <th>Detalle</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sesionesFiltradas.length > 0 ? (
                            sesionesFiltradas.map((item, idx) => (
                                <tr key={item.usuario_id}>
                                    <td>{idx + 1}</td>
                                    <td>{item.codigo_usuario}</td>
                                    <td>{item.nombre_completo}</td>
                                    <td>
                                        {(() => {
                                            const r = getRiesgo(item.total_activas);
                                            return (
                                                <span style={{ fontWeight: 'bold', color: r.color }}>
                                                    {r.label} — {item.total_activas} {item.total_activas === 1 ? 'activa' : 'activas'}
                                                </span>
                                            );
                                        })()}
                                    </td>
                                    <td>
                                        <ButtonView onClick={() => abrirModal(item)} />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} className="text-center text-gray-500 py-4">
                                    No se encontraron registros para los filtros seleccionados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Modal isOpen={modalSesion} className="sesiones-modal" backdrop={true} onClosed={() => setSesionSeleccionada(null)}>
                <ModalHeader className="modal-header">
                    <div className="titulo">
                        <h1>DETALLE DE SESIONES</h1>
                        <Button className="close-btn" onClick={cerrarModal}>X</Button>
                    </div>
                </ModalHeader>
                <div className="table-container">
                    <ModalBody className="modal-body">
                        {sesionSeleccionada && (
                            <>
                                <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '1rem' }}>
                                    <strong>{sesionSeleccionada.nombre_completo}</strong> — {sesionSeleccionada.codigo_usuario}
                                </p>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>IP</th>
                                            <th>Dispositivo</th>
                                            <th>Estado</th>
                                            <th>Inicio de sesión</th>
                                            <th>Cierre de sesión</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sesionSeleccionada.sesiones.map((s) => (
                                            <tr key={s.sesion_id}>
                                                <td>{s.ip_address || '—'}</td>
                                                <td>
                                                    {s.device_info || '—'}
                                                    {Number(s.dispositivo_reconocido) === 0 && (
                                                        <span title="Dispositivo no reconocido" style={{ marginLeft: 6, color: '#ef4444', fontWeight: 'bold', fontSize: 13 }}>
                                                            ⚠ Nuevo
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    {(() => {
                                                        const est = estados_sesion.find(e => e.tipo_id == s.estado);
                                                        const color = coloresEstado[Number(s.estado)] || '#6b7280';
                                                        return <span style={{ color, fontWeight: 'bold' }}>{est ? est.descripcion : s.estado}</span>;
                                                    })()}
                                                </td>
                                                <td>{formatFecha(s.fecha_login)}</td>
                                                <td>{formatFecha(s.fecha_cierre)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </>
                        )}
                    </ModalBody>
                </div>
            </Modal>
        </div>
    );
}

export default SesionesActivas;
